type DocumentLanguageTarget = {
  lang: string
}

export const documentLanguageFromPageProps = (props: unknown) => {
  if (typeof props !== "object" || props === null) return "en"

  const locale = (props as Record<string, unknown>).selected_locale

  return typeof locale === "string" && locale.trim().length > 0 ? locale : "en"
}

export const syncDocumentLanguage = (
  props: unknown,
  target: DocumentLanguageTarget = document.documentElement
) => {
  target.lang = documentLanguageFromPageProps(props)
}
